import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import './LanguageSelector.scss';
import LanguageMenu from './LanguageMenu';
import {toggleLanguageMenu} from '../../redux/actions';
import useWindowDimensions from "../../hooks/useWindowDimensions";

const LanguageSelector = props => {
    const languageSelectorRef = React.createRef();
    const {width} = useWindowDimensions();

    const handleClickOutsideLanguageSelector = (e) => {
        if (props.isLanguageMenuOpen && !languageSelectorRef.current?.contains(e.target)) {
            props.toggleLanguageMenu(false);
        }
    }

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutsideLanguageSelector);
        return function cleanup() {
            document.removeEventListener('mousedown', handleClickOutsideLanguageSelector);
        }
    })

    if (props.configuration && props.configuration.languages) {
        return (
            <div id="languageSelector" ref={languageSelectorRef}>
                <div id="languageButton" className={`${props.isLanguageMenuOpen ? 'active' : ''}`}
                     onClick={() => props.toggleLanguageMenu(!props.isLanguageMenuOpen)}>
                    <div className={`flag ${props.currentLanguage.code}`}>
                        {width > 576 ? props.currentLanguage.title : props.currentLanguage.code}
                    </div>
                    <img className={"dropdown-indicator"} alt="Language selector indicator"/>
                </div>
                <LanguageMenu/>
            </div>
        );
    } else {
        return null;
    }
};

const mapStateToProps = state => {
    return {...state};
};

export default connect(mapStateToProps, {toggleLanguageMenu})(LanguageSelector);